import { Component, Input } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
    selector: 'app-res-q-heatmap-chart',
    templateUrl: './res-q-heatmap-chart.component.html',
    styleUrl: './res-q-heatmap-chart.component.scss',
    standalone: false
})
export class ResQHeatmapChartComponent {
  @Input() data: any[] = [];
  @Input() series: any[] = [];
  @Input() default_series: any[] = [];

  legend = false;
  animations = false;
  xAxis = true;
  yAxis = false;
  showYAxisLabel = false;
  showXAxisLabel = true;
  min = 0;
  max = 100;
  colorScheme: string | Color = {
    name: 'myScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['transparent', '#15A607', '#F1D50A', '#F1960A', '#F11C0A'],
  };

  chartData: any[] = [];
  ready = false;

	showHeatmap() {
		this.ready = true;
		this.calculateHeatMapData(20);
	}

  calculateHeatMapData(currentTime: number) {
		const start = currentTime - 20;
		const dataChart = [];

		for (let index = start; index <= currentTime; index++) {
			const time = this.convertToTimerFormat(index);

      const time_data = {
				name: time,
				series: this.default_series.map(s => ({ ...s }))
			};

      for (let x = 0; x < this.default_series.length; x++) {
        if (index < this.data[x].timeline.length) {
          time_data.series[x].value = this.data[x].timeline[index];
          time_data.series[x].original = this.data[x].timeline[index];
        }
      }

      time_data.series.reverse();
			dataChart.push(time_data);
		}

		this.chartData = [...dataChart];

		if (!this.ready) {
			this.ready = true;
		}
	}

  updateHeatmap(currentTime: number) {
		if (currentTime > 20) {
			this.calculateHeatMapData(currentTime);
		} else {
			this.calculateHeatMapData(20);
		}
	}

  tooltipText(data: any): string {
		const cell = JSON.parse(JSON.stringify(data)).cell;

		let spanContent;

		if (Array.isArray(cell.original)) {
			const listItems = cell.original.map((item: any) => `<li>${item}</li>`).join('');
			spanContent = `<ol>${listItems}</ol>`;
		} else {
			spanContent = cell.original;
		}

		const span = `<span>${spanContent}</span>`;

		const tool = `
			<div class="p-1 fs-16">
				${cell.series} - ${cell.name}
				<hr class="m-0">
				${span}
			</div>
		`;

		return tool;
	}

  convertToTimerFormat(seconds: number) {
		if (seconds < 3600) {
			// Display "mm:ss" format for the first 60 minutes
			const minutes = Math.floor(seconds / 60);
			const formattedSeconds = (seconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			return `${formattedMinutes}:${formattedSeconds}`;
		} else {
			// After 60 minutes, switch to "hh:mm:ss" format
			const hours = Math.floor(seconds / 3600);
			const remainingSeconds = seconds % 3600;
			const minutes = Math.floor(remainingSeconds / 60);
			const formattedSeconds = (remainingSeconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			const formattedHours = hours.toString().padStart(2, "0");
			return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		}
	}

}
